export default "__VITE_ASSET__D7sjSdQ7__"